/*
  Protocol state
*/
export default {
  list: []
}
